var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilterIconHorizontal = function SvgFilterIconHorizontal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 96 90",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88.91,44.4998a3.38,3.51711 0 0 1 -3.38,3.51711l-51.44,0a11.15,11.60229 0 0 1 -21.24,0l-6.34,0a3.38,3.51711 0 0 1 0,-7.04463l6.34,0a11.15,11.60229 0 0 1 21.24,0l51.44,0a3.38,3.51711 0 0 1 3.38,3.52752zm-3.42,23.37107l-11.8,0a11.15,11.60229 0 0 0 -21.24,0l-46,0a3.38,3.51711 0 1 0 0,7.04463l46,0a11.15,11.60229 0 0 0 21.24,0l11.8,0a3.38,3.51711 0 1 0 0,-7.04463zm-79,-46.73174l45.96,0a11.15,11.60229 0 0 0 21.24,0l11.84,0a3.38,3.51711 0 0 0 0,-7.04462l-11.84,0a11.15,11.60229 0 0 0 -21.24,0l-45.94,0a3.38,3.51711 0 0 0 0,7.03421l-0.02,0.01041z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterIconHorizontal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-icon-horizontal.768237e3.svg";
export { ForwardRef as ReactComponent };